module.exports = __webpack_public_path__ + "img/learner-quiz-Moose intro.29c75ba3.png";